"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearch = void 0;
var react_1 = require("react");
var __1 = require("../..");
function useSearch(props) {
    var _this = this;
    var _a = __assign({}, props), value = _a.value, multiple = _a.multiple, options = _a.options, filterItems = _a.filterItems, debugName = _a.debugName, defaultOptions = _a.defaultOptions, loadOptions = _a.loadOptions, onLoadOptionsError = _a.onLoadOptionsError;
    var _b = __read((0, __1.useBooleanToggle)(false), 2), loading = _b[0], setLoading = _b[1];
    var isValueArray = __1.TypeGuards.isArray(value) && multiple;
    var _c = __read((0, react_1.useState)(function () {
        if (isValueArray) {
            return defaultOptions.filter(function (o) { return value.includes(o.value); });
        }
        var _option = defaultOptions.find(function (o) { return o.value === value; });
        if (!_option) {
            return [];
        }
        return [_option];
    }), 2), labelOptions = _c[0], setLabelOptions = _c[1];
    var _d = __read((0, react_1.useState)(defaultOptions), 2), filteredOptions = _d[0], setFilteredOptions = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), setSearchInput = _e[1];
    function load() {
        return __awaiter(this, void 0, void 0, function () {
            var options_1, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, loadOptions('')];
                    case 2:
                        options_1 = _a.sent();
                        setFilteredOptions(options_1);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        onLoadOptionsError(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    var onChangeSearch = function (searchValue) { return __awaiter(_this, void 0, void 0, function () {
        var _opts_1, e_2, _opts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSearchInput(searchValue);
                    if (!!!loadOptions) return [3 /*break*/, 5];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadOptions(searchValue)];
                case 2:
                    _opts_1 = _a.sent();
                    setFilteredOptions(_opts_1);
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error("Error loading select options [".concat(debugName, "], e"));
                    onLoadOptionsError === null || onLoadOptionsError === void 0 ? void 0 : onLoadOptionsError(e_2);
                    return [3 /*break*/, 4];
                case 4:
                    setTimeout(function () {
                        setLoading(false);
                    }, 0);
                    return [2 /*return*/];
                case 5:
                    _opts = filterItems(searchValue, options);
                    setFilteredOptions(_opts);
                    return [2 /*return*/];
            }
        });
    }); };
    return { loading: loading, setLoading: setLoading, labelOptions: labelOptions, setLabelOptions: setLabelOptions, filteredOptions: filteredOptions, load: load, onChangeSearch: onChangeSearch };
}
exports.useSearch = useSearch;
